import React, { useState } from "react";
import { useAdminAuth } from "./AdminAuth";

const AdminLogin: React.FC = () => {
  const { login } = useAdminAuth();
  const [user, setUser] = useState("");
  const [pass, setPass] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    const errMsg = await login(user, pass);
    if (errMsg) setError(errMsg);
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#0F172A] to-[#1A2540]">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-10">
        {/* Logo / Başlık */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full mb-4"
            style={{ background: "linear-gradient(135deg, #8B1428 0%, #0F4C81 100%)" }}>
            <i className="fa-solid fa-lock text-white text-2xl" />
          </div>
          <h1 className="text-2xl font-extrabold text-gray-900">Admin Paneli</h1>
          <p className="text-gray-500 text-sm mt-1">Bursa Trabzonlular Derneği</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5" autoComplete="off">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1.5">E-posta</label>
            <input
              type="email"
              value={user}
              onChange={e => { setUser(e.target.value); setError(null); }}
              required
              autoComplete="off"
              className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#8B1428] text-gray-900"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1.5">Şifre</label>
            <div className="relative">
              <input
                type={showPass ? "text" : "password"}
                value={pass}
                onChange={e => { setPass(e.target.value); setError(null); }}
                required
                className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#8B1428] pr-10"
                placeholder="••••••••"
              />
              <button type="button" onClick={() => setShowPass(s => !s)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-700">
                <i className={`fa-solid ${showPass ? "fa-eye-slash" : "fa-eye"} text-sm`} />
              </button>
            </div>
          </div>

          {error && (
            <div className="flex items-center gap-2 text-red-600 text-sm bg-red-50 px-4 py-3 rounded-lg">
              <i className="fa-solid fa-triangle-exclamation" />
              {error}
            </div>
          )}

          <button type="submit" disabled={loading}
            className="w-full text-white font-bold py-3 rounded-lg transition-colors text-sm disabled:opacity-60"
            style={{ background: "linear-gradient(135deg, #8B1428 0%, #0F4C81 100%)" }}>
            {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;